/**
 * Frontend error tracking. Loaded only when VITE_SENTRY_DSN is set, and the
 * SDK is imported lazily so it never lands in the main bundle for builds
 * without a DSN. It also waits until the page has loaded and the browser is
 * idle, so the SDK never competes with the first screen and its photos.
 * Only `init` is imported, which lets the bundler drop the rest of the SDK.
 * Request bodies and auth are never sent; the API strips its own. Failures
 * here are swallowed so monitoring can't break the app.
 */
export function startErrorTracking() {
  const dsn = import.meta.env.VITE_SENTRY_DSN
  if (!dsn) return
  const load = () =>
    import('@sentry/react')
      .then(({ init }) => {
        init({
          dsn,
          environment: import.meta.env.MODE,
          release: import.meta.env.VITE_VERCEL_GIT_COMMIT_SHA || undefined,
          sendDefaultPii: false,
          tracesSampleRate: 0,
        })
      })
      .catch(() => {})
  const whenIdle = () =>
    'requestIdleCallback' in window
      ? window.requestIdleCallback(load, { timeout: 3000 })
      : setTimeout(load, 1)
  if (document.readyState === 'complete') whenIdle()
  else window.addEventListener('load', whenIdle, { once: true })
}
